import { Staff } from '@/models/staff';
import { Lottery, LuckyDetail } from './detail/const';
import { ImageModel, ConfigModel, ProductModel, StreamerModel, LiveVideoModel, LiveStreamProductModel } from '@/models';
import { number } from 'yup';
import { ProductDiscount } from '../products/shared';

interface Product extends ProductModel {
  images: ImageModel[];
  product_discount: ProductDiscount | null;
  last_product_discounts: ProductDiscount[];
}

interface LiveStreamProduct extends LiveStreamProductModel {
  products: Product;
}

export interface LiveVideo extends LiveVideoModel {
  city: string;
  images: ImageModel[];
  config: ConfigModel;
  live_streamer: StreamerModel;
  live_stream_product: LiveStreamProduct[];
  lottery_game: Lottery[];
  lucky: LuckyDetail;
}

export type LiveVideosTypes = { edges: LiveVideo[]; count: number };

export const LiveVideosDefault = { edges: [], count: 0 };

export interface LiveSchedule {
  id: number;
  name: string;
  description: string;
  staffs: {
    id: number;
    fullname: string;
    avatar: string;
  };
  live_stream_schedule_streamers: {
    live_streamer: StreamerModel;
    live_streamer_id: number;
  }[];
  start_datetime: string;
  updated_at: string;
  created_at: string;
}
